import { Component, OnInit } from '@angular/core';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';

@Component({
  selector: 'app-custom-notification',
  templateUrl: './app-custom-notification.component.html'
})

export class CustomNotificationComponent implements OnInit {
  public isMultipleNotification: boolean = this._coreHelper.notificationData.isMultipleNotification;
  public notificationUnreadCount: number = this._coreHelper.notificationData.notificationUnreadCount;
  public notificationData = {
    notificationTitle: this._coreHelper.notificationData.notificationTitle,
    notificationMessage: this._coreHelper.notificationData.notificationMessage,
    notificationDate: this._coreHelper.notificationData.notificationDate,
    notificationTillNow: this._coreHelper.notificationData.notificationTillNow,
  };
  constructor(public _coreHelper: CoreHelperService) {
  }
  ngOnInit(): void {
    this._coreHelper.clearNotificationData();
  }
}
